import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
// import {Table} from 'antd'
// import { Checkbox } from 'antd';
import CustomCell from '../../../pages/universalDetails/niinDetailTables/subcomponents/CustomItemCell';
import Header from '../../../pages/universalDetails/niinDetailTables/subcomponents/Header';
import ItemCodes from '../../../config/SegCCodeDef.json';
import './Drawings.scss';

export default class ProcurementHistoryGrid extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
  };

  render() {
    const { data } = this.props;

    const column = [
      {
        Header: 'CAGE',
        accessor: 'cage',
      },
      {
        Header: 'Part Number',
        accessor: 'refNbr',
      },
      {
        Header: <Header title="RNCC" tooltip={ItemCodes.RNCC.definition} />,
        accessor: 'rncc',
        Cell: cellProps => <CustomCell type="RNCC" value={cellProps.value} />,
      },

      {
        Header: <Header title="RNVC" tooltip={ItemCodes.RNVC.definition} />,
        accessor: 'rnvc',
        Cell: cellProps => <CustomCell type="RNVC" value={cellProps.value} />,
      },

      {
        Header: <Header title="DAC" tooltip={ItemCodes.DAC.definition} />,
        accessor: 'dac',
        Cell: cellProps => <CustomCell type="DAC" value={cellProps.value} />,
      },

      {
        Header: <Header title="RNSC" tooltip={ItemCodes.RNSC.definition} />,
        accessor: 'rnsc',
        Cell: cellProps => <CustomCell type="RNSC" value={cellProps.value} />,
      },

      {
        Header: <Header title="HCC" tooltip={ItemCodes.HCC.definition} />,
        accessor: 'hcc',
        Cell: cellProps => <CustomCell type="HCC" value={cellProps.value} />,
      },

      {
        Header: 'MSDS',
        accessor: 'msds',
      },
    ];

    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={data}
          columns={column}
          defaultPageSize={data.length}
          showPagination={false}
          style={{ textAlign: 'center' }}
        />
        {/* <Table dataSource={drawings} columns={columns} /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/RefNumbers/DrawingsGrid.jsx